import { startOfLocalWeek } from "../../../lib/timezone.js";
import type { CalendarViewMode } from "./types.js";

/**
 * Заголовок периода. Раньше его рисовал тулбар библиотеки; теперь хром наш,
 * поэтому подпись собираем сами — и по-русски, не полагаясь на локаль браузера.
 */
const UI_LOCALE = "ru-RU";

function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function formatRangeLabel(view: CalendarViewMode, anchor: Date): string {
  if (view === "dayGridMonth") {
    return capitalize(
      new Intl.DateTimeFormat(UI_LOCALE, { month: "long", year: "numeric" }).format(anchor),
    );
  }

  if (view === "resourceTimeGridDay" || view === "timeGridDay") {
    return capitalize(
      new Intl.DateTimeFormat(UI_LOCALE, {
        weekday: "long",
        day: "numeric",
        month: "long",
      }).format(anchor),
    );
  }

  const start = startOfLocalWeek(anchor);
  const end = new Date(start);
  end.setDate(end.getDate() + 6);

  const sameYear = start.getFullYear() === end.getFullYear();
  const sameMonth = sameYear && start.getMonth() === end.getMonth();

  // «10–16 августа» внутри месяца, «28 июля – 3 августа» на стыке.
  if (sameMonth) {
    const day = new Intl.DateTimeFormat(UI_LOCALE, { day: "numeric" }).format(start);
    const tail = new Intl.DateTimeFormat(UI_LOCALE, { day: "numeric", month: "long" }).format(end);
    return `${day}–${tail}`;
  }

  const options: Intl.DateTimeFormatOptions = sameYear
    ? { day: "numeric", month: "long" }
    : { day: "numeric", month: "long", year: "numeric" };
  const from = new Intl.DateTimeFormat(UI_LOCALE, options).format(start);
  const to = new Intl.DateTimeFormat(UI_LOCALE, options).format(end);
  return `${from} – ${to}`;
}

/** Шаг навигации «назад/вперёд» соответствует показанному периоду. */
export function shiftAnchor(view: CalendarViewMode, anchor: Date, direction: -1 | 1): Date {
  const next = new Date(anchor);
  if (view === "dayGridMonth") {
    next.setMonth(next.getMonth() + direction);
    return next;
  }
  next.setDate(next.getDate() + direction * (view === "timeGridWeek" ? 7 : 1));
  return next;
}
